import { getRateRangeString, getMinRateString } from '../../helpers/humanization.js';

const getMortgageTerms = item => {
    const conditions = [];
    const { minRate, maxRate, minInitialAmount, maxInitialAmount, minPsk, maxPsk } = item;
    if (minPsk >= 0 && maxPsk >= 0) {
        const pskValue = getRateRangeString({ from: minPsk, to: maxPsk, fractionDigits: 3 }, '');
        conditions.push({ value: pskValue, description: 'Полная ст-ть кредита', wide: true, key: 'pskValue' });
    }
    const rateValue = getMinRateString({ from: minRate, to: maxRate }, true);
    rateValue && conditions.push({ value: rateValue, description: 'Ставка', key: 'rate' });
    const initialAmountValue = getMinRateString({
        from: minInitialAmount,
        to: maxInitialAmount,
    }, true, 'Без взноса');
    conditions.push({ value: initialAmountValue, description: 'Перв. взнос', key: 'initialAmount' });
    return conditions;
};

export { getMortgageTerms };
//# sourceMappingURL=mortgage.js.map
